<template>
  <component
    :is="icon"
    :size="48"
    class="p-2 rounded-full text-nami-nami-blue bg-neutral-300 dark:bg-neutral-700"
  />
</template>

<script setup lang="ts">
import { IconPlaceholder } from "@tabler/icons-vue";

defineProps<{
  icon: typeof IconPlaceholder;
}>();
</script>
